var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('strong', [_vm._v("Change Password")])]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Your Password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password",
      "placeholder": "Enter Password.."
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "New Password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password",
      "placeholder": "Enter New Password.."
    },
    model: {
      value: (_vm.newpass),
      callback: function($$v) {
        _vm.newpass = $$v
      },
      expression: "newpass"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Re-Type New Password",
      "description": "Please enter your password."
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password",
      "placeholder": "Re-Type New Password.."
    },
    model: {
      value: (_vm.retypepass),
      callback: function($$v) {
        _vm.retypepass = $$v
      },
      expression: "retypepass"
    }
  })], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": _vm.change
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d091068","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/account/ChangePass.vue
// module id = 164
// module chunks = 0